import { AnimatePresence, motion } from "motion/react";
import { useVideoSettings } from "../../contexts/videoSettings/videoSettings.hook";
import { useEffect } from "react";
import { useMenu } from "../../contexts/menu/menu.hook";
import { usePrefersReducedMotion } from "../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import { MenuContentOptions } from "../../contexts/menu/Menu.types";
import styles from "./Footer.module.scss";
import useResponsive from "../../hooks/useResponsive";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh, faVolumeXmark } from "@fortawesome/free-solid-svg-icons";

export const Footer = () => {
  const { isPlayingIntroVideo, isMuted, setIsMuted } = useVideoSettings();
  const { setIsMenuOpen, menuContent, setMenuContent, menuBg } = useMenu();
  const { prefersReducedMotion } = usePrefersReducedMotion();
  const { isMobile } = useResponsive();

  const handleTrailerClick = () => {
    setMenuContent(MenuContentOptions.TRAILER);
  };

  useEffect(() => {
    if (menuContent === MenuContentOptions.TRAILER && menuBg === "black") {
      setIsMenuOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuContent, menuBg]);

  const footerVariants = {
    hidden: prefersReducedMotion
      ? { opacity: 1, y: 0 }
      : { opacity: 0, y: "150%" },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <AnimatePresence>
      {!isPlayingIntroVideo && (
        <motion.footer
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={{ duration: 1 }}
          variants={footerVariants}
          className={styles.footerWrapper}
        >
          <nav className={styles.footerNav}>
            <div>
              {isMobile && (
                <button onClick={handleTrailerClick}>Play Trailer</button>
              )}
              {!prefersReducedMotion && !isMobile && (
                <button
                  className={styles.volumeBtn}
                  onClick={() => setIsMuted(!isMuted)}
                >
                  {isMuted ? (
                    <FontAwesomeIcon icon={faVolumeXmark} />
                  ) : (
                    <FontAwesomeIcon icon={faVolumeHigh} />
                  )}
                </button>
              )}
            </div>
          </nav>
        </motion.footer>
      )}
    </AnimatePresence>
  );
};
